import PlaidIcon from './PlaidLogo.svg';

type ImageProps = React.JSX.IntrinsicElements['div'] & {
  width?: string;
  alt?: string;
}

export const PlaidLogo = ({width = "126px", alt = "Plaid icon", ...props}: ImageProps) => <div {...props}><img src={PlaidIcon} width={width} alt={alt} /></div>
export default PlaidLogo;